import 'regenerator-runtime/runtime'

import api from "@/services/apiService"

class MarketService {

  /**
   * ดึงรายการงวดหวยล่าสุด
   */
  getRound(marketId) {
    return new Promise((resolve, reject) => {
      api.get(process.env.VUE_APP_API_MAIN + 'market/round/' + marketId)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

  /**
   * ดึงรายการงวดหวยทั้งหมด
   */
  getRounds(marketId) {
    return new Promise((resolve, reject) => {
      api.get(process.env.VUE_APP_API_MAIN + 'market/rounds/' + marketId)
      .then(function(response) {
        resolve(response.data)
      })
      .catch(function(error) {
        console.log(error)
        reject(error)
      })
    })
  }

}

export default new MarketService()
